module.exports = __webpack_public_path__ + "img/noauth.545c28fc.png";